<template>
  <div class="unit-toggles">
    <div class="measure-toggles" :class="{'show-metric': snowfallInMetric}">
      <a href="#snowbase-cm-metric" class="cm noscroll" @click.prevent="toggleSnowfallMetric(true)">
        <span tabindex="-1">cm</span>
      </a>
      <a href="#snowbase-cm-imperial" class="in noscroll" @click.prevent="toggleSnowfallMetric(false)">
        <span tabindex="-1">in</span>
      </a>
    </div>

    <div class="total-snowfall-toggles" :class="{'show-total': showTotalSnowfall}">
      <span class="total-snowfall-text">{{ $t('total snowfall') }}</span>
      <a href="#total-snowfall-on" class="on noscroll" @click.prevent="toggleSnowfallUnit(true)">
        <span tabindex="-1">{{ $t('on') }}</span>
      </a>
      <a href="#total-snowfall-cm" class="off noscroll" @click.prevent="toggleSnowfallUnit(false)">
        <span tabindex="-1">{{ $t('off') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ChartUnitToggles',
  props: [],
  components: { },
  computed: {
    snowfallInMetric() {
      return this.snowfallChartSettings.snowfallInMetric == true;
    },
    showTotalSnowfall() {
      return this.snowfallChartSettings.showTotalSnowfall == true;
    },
    ...mapState(['snowfallChartSettings']),
  },

  methods: {
    toggleSnowfallMetric(setting) {
      this.$store.dispatch('setSnowfallMetric', setting);
    },
    toggleSnowfallUnit(setting) {
      this.$store.dispatch('setTotalSnowfall', setting);
    },
  },
};
</script>

<style lang="scss" scoped>
#mtnDashboardApp {
  .unit-toggles {
    display: flex;
    flex-basis: 22%;
    margin-top: 5px;
    white-space: nowrap;
    .dashboard-block {
      .measure-toggles, .total-snowfall-toggles {
        color: $toggles-text-color;
        font-family: $base-font-regular;
        font-size: 12px;
        line-height: 1;
        width: 55px;
        @media (min-width: $tablet) {
          font-size: 14px;
        }
      }
    }
    .measure-toggles {
      margin-right: 10px;
      .cm {
        border-right: 1px solid $light-gray;
        margin-right: 5px;
        padding-right: 5px;
        span {
          color: $light-gray;
        }
      }
      .in {
        span {
          color: $toggles-text-color;
          font-family: $base-font-bold;
          font-weight: $toggle-selected-font-weight;
        }
      }
      &.show-metric {
        .cm {
          span {
            color: $toggles-text-color;
            font-family: $base-font-bold;
            font-weight: $toggle-selected-font-weight;
          }
        }
        .in {
          span {
            color: $light-gray;
            font-family: $base-font-regular;
            font-weight: $base-font-weight;
          }
        }
      }
    }
    .total-snowfall-toggles {
      letter-spacing: 1px;
      width: auto;
      .total-snowfall-text {
        display: inline-block;
        margin-right: 5px;
        color: $light-gray;
      }
      a {
        display: inline-block;
        span {
          color: $toggles-text-color;
        }
        &.on {
          border-right: 1px solid $light-gray;
          margin-right: 5px;
          padding-right: 5px;
          span {
            color: $light-gray;
          }
        }
        &.off {
          color: $toggles-text-color;
          font-family: $base-font-bold;
          font-weight: $toggle-selected-font-weight;
        }
      }
      &.show-total {
        .on {
          span {
            color: $toggles-text-color;
            font-family: $base-font-bold;
            font-weight: $toggle-selected-font-weight;
          }
        }
        .off {
          span {
            color: $light-gray;
            font-family: $base-font-regular;
            font-weight: $base-font-weight;
          }
        }
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "total snowfall": "Précipitations de neige totales",
  "on": "oui",
  "off": "non"
}
</i18n>
